<template>
	<form class="form form--has-fixed-group" novalidate>
		<div ref="success" v-show="success" class="alert alert--success">
			{{ currentUser ? 'Your subscriptions have been saved' : 'User subscriptions have been updated' }}
		</div>

		<fieldset class="form__group">
			<ListSectors :counts="false">
				<template slot="actions" slot-scope="{ sector }">
					<input :id="`follow-${sector.id}`" class="toggle" name="subscribed" type="checkbox"
					       v-model="formData.subscribed" :value="sector.id"/>
					<label :for="`follow-${sector.id}`" class="toggle">
						{{ formData.subscribed.indexOf(sector.id) > -1 ? 'Unfollow' : 'Follow' }}
					</label>
				</template>
			</ListSectors>
		</fieldset>

		<div class="form__group form__group--submit-fixed">
			<button class="btn btn--primary" @click.prevent="submit"
			        v-wait:disabled="waitName">Save Changes
			</button>
		</div>
	</form>
</template>

<script>
	import API from './../../../api';
	import ListSectors from '../../List/ListSectors';
	import UserFormTab from './UserFormTab';

	export default {
		name: 'UserFormFollowedSectors',
		mixins: [UserFormTab],
		components: {
			ListSectors,
		},
		data() {
			return {
				waitName: 'updateSubscribed',
				formData: {
					subscribed: []
				},
			};
		},
		methods: {
			save() {
				return API.updateUserSubscribed(this.id, this.formData.subscribed);
			},
		}
	}
</script>
